// extracted by mini-css-extract-plugin
export default {"base":"vp_iIdm4","label":"vp_JS4vW","value":"vp_o8hzy"};